import type { StatusTone } from '../contracts/common';
import type { ContextProfileKind, MemoryProposalStatus, MemorySourceType } from '../contracts/context';

/** Profile kontekstu (Figma 10 Wiedza: „Profil właściciela”, „Oferta i stawki”). */
export const CONTEXT_PROFILE_KIND_LABELS: Record<ContextProfileKind, string> = {
  owner: 'Profil właściciela',
  business: 'Oferta i stawki',
};

export const MEMORY_PROPOSAL_STATUS_LABELS: Record<MemoryProposalStatus, string> = {
  proposed: 'Propozycja',
  accepted: 'Przyjęta',
  rejected: 'Odrzucona',
};

export const MEMORY_PROPOSAL_STATUS_TONES: Record<MemoryProposalStatus, StatusTone> = {
  proposed: 'accent',
  accepted: 'success',
  rejected: 'neutral',
};

/** Skąd propozycja zmiany pamięci (lista w Ustawieniach → AI i pamięć). */
export const MEMORY_SOURCE_TYPE_LABELS: Record<MemorySourceType, string> = {
  remember_command: 'Polecenie „zapamiętaj”',
  email_edit: 'Poprawka maila',
  meeting: 'Spotkanie',
  message: 'Wiadomość',
  ai_job: 'Zadanie AI',
  agent_run: 'Przebieg AI',
  task: 'Zadanie',
  manual: 'Ręcznie',
};
